import React, { useCallback, useContext } from 'react';
import { Drawer as BaseDrawer,
  Toolbar,
  Box,
  useMediaQuery,
  ClickAwayListener
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { AppContext } from 'core/context';
import NavbarMenuItems from 'utils/navbarItems';
import NavList from './NavList';

const drawerWidth = 260;
const defaultNavbarMenuItems = [];
const menuItems = [
  ...defaultNavbarMenuItems,
  ...NavbarMenuItems
];

const Drawer = styled(BaseDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    '& .MuiDrawer-paper': {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerWidth, 
      marginLeft: `-${drawerWidth}px`,
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeIn,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('margin', {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: drawerWidth,
        // width: theme.spacing(7),
        // [theme.breakpoints.up('sm')]: {
        //   width: theme.spacing(9),
        // },
        marginLeft: 0,
      }),
    },
    '& .Mui-selected': {
      color: theme.palette.primary.main,
      borderLeft: `6px solid ${theme.palette.primary.main}`,
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
    '& .Mui-selected .MuiListItemIcon-root': {
      color: theme.palette.primary.main,
      // backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
    // '& .MuiListItemButton-root:hover': {
    //   color: theme.palette.primary.main,
    //   // borderRight: `6px solid ${theme.palette.primary.main}`,
    //   backgroundColor: 'rgba(0, 0, 0, 0.04)',
    // },

  }),
);




const Navbar = () => {
  
  /* Hooks */
  const max1540 = useMediaQuery('(max-width:1540px)');
  const { isSideDrawerOpen, updateAppContext } = useContext(AppContext);
  
  function onNavLinkClick() {
    if(max1540){
      updateAppContext({
        isSideDrawerOpen: false
      });
    }
  }

  const handleClickAway = useCallback((e) => {
    const isMenuIcon = e.target.closest('#navMenubutton');
    if(!isMenuIcon && max1540){
      updateAppContext({
        isSideDrawerOpen: false
      });
    }
  },[max1540, updateAppContext]);

  return (
    <ClickAwayListener mouseEvent="onMouseDown" onClickAway={(e)=>handleClickAway(e)}>
      <Drawer sx={{ height: '100vh',overflow: 'auto', }} variant="permanent" className="drawer-mobile" open={isSideDrawerOpen}>
        <Toolbar />
        <Box sx={{ mb: '60px' }}>
          <NavList menuItems={menuItems} isSideDrawerOpen={isSideDrawerOpen} onNavLinkClick={onNavLinkClick}/>
        </Box>
      </Drawer>
    </ClickAwayListener>
  );
};
 
export default Navbar;
